module.exports = __webpack_public_path__ + "img/takeOrder.9312c84e.png";